<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import MarqueeContent from './MarqueeContent.vue';

defineProps<{
	announcements: string[];
}>();

const { deviceType } = useDeviceType();

const headerVisible = inject('headerVisible') as Ref<boolean>;
const router = useRoute();

const announcementContainer = ref();
const routeName = computed(() => {
	return router.path.includes('/products');
});
</script>

<template>
	<div
		:data-header-visible="
			routeName === true ? true : deviceType === 'mobile' ? headerVisible : true
		"
		:data-device-type="deviceType"
		class="w-full bg-gray-950 block sm:block md:block lg:block sticky top-0 z-50"
	>
		<div
			ref="announcementContainer"
			class="overflow-hidden h-auto min-h-[40px] relative flex items-center"
		>
			<div
				class="flex w-full overflow-hidden relative h-full font-sans text-[12.8px] leading-[19.2px] font-medium pt-[11.2px] pb-[11.2px] text-white whitespace-nowrap"
			>
				<MarqueeContent :announcements="announcements" />
				<MarqueeContent :announcements="announcements" aria-hidden="true" />
			</div>
		</div>
	</div>
</template>

<style scoped>
[data-device-type='mobile'][data-header-visible='true'] {
	top: 0;
}
[data-device-type='mobile'][data-header-visible='false'] {
	top: -42px;
}

/* Desktop always visible */
[data-device-type='desktop'] {
	top: 0;
}
[data-device-type='tablet'] {
	top: 0;
}
</style>
